import { useState } from 'react';

import { Avatar } from 'ui';
import { Character } from 'ui/characters';

const UserAvatar = ({
  children, className, gender = 'male', tone = 2, type, size = 49, ...attrs
}) => {
  const hasAvatarProps = { isUserAvatar: true };
  const noAvatarProps = {
    isUserAvatar: false,
    isUnknownAvatar: true,
  };
  const [avatarProps, setAvatarProps] = useState(type ? hasAvatarProps : noAvatarProps);
  const handleError = () => {
    setAvatarProps(noAvatarProps);
  };
  return (
    <Avatar size={size} {...avatarProps} {...attrs}>
      <Character type={type} tone={tone} gender={gender} onError={handleError} />
    </Avatar>
  );
};

export default UserAvatar;
